export default __webpack_public_path__ + "static/media/wave-static-02.abd9b015.svg";